import cs from 'classnames';

const CounterBadge = ({ count, children }) => {
  const overflowCount = count > 99;
  return (
    <div className="z-10 inline-block">
      {children}
      {count > 0 && (
        <div className="absolute right-0 top-0 flex size-[12px] flex-col items-center justify-center rounded-lg bg-red-500 px-1">
          <span
            className={cs(
              'text-center font-semibold leading-[14px] text-white',
              overflowCount ? 'text-[5px]' : 'text-[8px]'
            )}>
            {overflowCount ? '99+' : count}
          </span>
        </div>
      )}
    </div>
  );
};

export default CounterBadge;
